export const REQUEST_MYPHOTOS_GALLERY_FOLDERS_FETCH_EM =
  "REQUEST_MYPHOTOS_GALLERY_FOLDERS_FETCH_EM";
export const FETCH_MYPHOTOS_GALLERY_FOLDERS_EM_SUCCESS =
  "FETCH_MYPHOTOS_GALLERY_FOLDERS_EM_SUCCESS";
export const FETCH_MYPHOTOS_GALLERY_FOLDERS_EM_FAILURE =
  "FETCH_MYPHOTOS_GALLERY_FOLDERS_EM_FAILURE";

export const CLEAR_MYPHOTOS_GALLERY_FOLDERS_EM_STATES =
  "CLEAR_MYPHOTOS_GALLERY_FOLDERS_EM_STATES";
